/**
 * The browser no longer keeps its authorized-link token itself. The server
 * holds it in an HttpOnly cookie (app/services/link_cookie.py), and the page
 * learns it from /api/link/validate, the one place that reads that cookie.
 *
 * What is left here is the handoff from before the cookie: a token the old
 * frontend left in localStorage is offered to /api/link/validate once, which
 * moves it into the cookie, and the localStorage copy is then dropped.
 */

const LEGACY_STORAGE_KEY = "embroidery_token";

// Cookie-touching requests in local dev cross from :3000 to :5555, a
// different origin, where fetch leaves cookies out unless asked. In prod
// the API is same-origin and this changes nothing.
export const WITH_COOKIE: RequestInit = { credentials: "include" };

/** A token the pre-cookie frontend left behind, if any. */
export function legacyToken(): string | null {
  return localStorage.getItem(LEGACY_STORAGE_KEY);
}

/** Once the cookie holds the token, the old copy would only resurrect it
 *  after a log out. */
export function forgetLegacyToken(): void {
  localStorage.removeItem(LEGACY_STORAGE_KEY);
}
